import { useClient } from 'modules/settings/providers/ClientProvider';
import { ReactNode } from 'react';
import AdminFooter from 'ui/theme/AdminFooter';
import Footer from 'ui/theme/Footer';
import GlobalStyle from 'ui/theme/global-style';
import Header from 'ui/theme/Header';
import SalesRepFooter from 'ui/theme/SalesRepFooter';
import TimerLoader from 'ui/TimerLoader';
import { LayoutInterface } from 'ui/uiTypes';

import { Wrapper } from './styles';

interface LayoutProps {
  children: ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
  showLinks?: boolean;
  backgroundColor?: string;
  showSidebars?: boolean;
  hideTopNav?: boolean;
  isAdvisorView?: boolean;
  isAdminPortalPage?: boolean;
  isOverflowHidden?: boolean;
  isSalesrepShadow?: boolean;
  height?: string;
  minHeight?: string;
  handleNavigationClick?: (link: string) => void;
  handleAdvisorViewOpen?: () => void;
}

const Layout: React.FC<LayoutProps & LayoutInterface> = ({
  variant,
  children,
  showHeader = true,
  showFooter = true,
  showLinks = true,
  isAdmin = false,
  isAdminPortalPage = false,
  isSalesRep = false,
  hideTopNav = false,
  adminIsAuthenticated = false,
  showSidebars,
  backgroundColor,
  leftLoggedingMenu,
  rightNonLoggMenu,
  title,
  isAdvisorView,
  isOverflowHidden,
  isSalesrepShadow = true,
  height,
  minHeight,
  handleNavigationClick,
  handleAdvisorViewOpen,
}) => {
  const { restartTimeLeft } = useClient();

  if (restartTimeLeft) return <TimerLoader timeLeft={restartTimeLeft} />;

  return (
    <>
      <GlobalStyle backgroundColor={backgroundColor} />
      {showHeader && (
        <Header
          {...{
            showSidebars,
            showLinks,
            variant,
            leftLoggedingMenu,
            rightNonLoggMenu,
            isAdmin,
            isAdminPortalPage,
            isSalesRep,
            adminIsAuthenticated,
            hideTopNav,
            title,
            isAdvisorView,
            isSalesrepShadow,
            handleAdvisorViewOpen,
            handleNavigationClick,
          }}
        />
      )}
      <Wrapper
        topNav={hideTopNav}
        isOverflowHidden={isOverflowHidden}
        height={height}
        minHeight={minHeight}
      >
        {children}
      </Wrapper>
      {showFooter && !isAdmin && !isSalesRep && <Footer />}
      {showFooter && isAdmin && !isSalesRep && <AdminFooter />}
      {showFooter && !isAdmin && isSalesRep && <SalesRepFooter />}
    </>
  );
};

export default Layout;
